import { OdooService } from '@/api/odoo'
import { CustomComponentContext, CustomComponentContextType } from '@/utils/contexts/CustomComponentContext'
import { Input, InputDate, Spinner } from 'alurkerja-ui'
import moment from 'moment'
import { useContext, useEffect, useState } from 'react'
import { Controller } from 'react-hook-form'
import { countNonBusinessDaysAndDuration } from '@/utils/functions/countNonBusinessDaysAndDuration'
import { filterDate } from '@/utils/functions/filterDate'

// eslint-disable-next-line react-refresh/only-export-components
export const specPerizinanPilihJam = [
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Tanggal Mulai Cuti',
    name: 'leave_started_date',
    type: 'text',
  },
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Tanggal Selesai Cuti',
    name: 'leave_ended_date',
    type: 'text',
  },
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Durasi Cuti (Hari)',
    name: 'leave_duration',
    type: 'text',
  },
]

export default function StartProcessCustom() {
  const { setValue, taskData, control } = useContext<CustomComponentContextType>(CustomComponentContext)
  const { data: holidaysData, isLoading: isLoadingHolidays } = OdooService.useGetHolidays()

  const defaultValueDate = {
    minDate: taskData?.variables?.leave_started_date
      ? moment(taskData?.variables?.leave_started_date, 'DD-MM-YYYY').format('YYYY-MM-DD')
      : null,
    maxDate: taskData?.variables?.leave_ended_date
      ? moment(taskData?.variables?.leave_ended_date, 'DD-MM-YYYY').format('YYYY-MM-DD')
      : null,
  }

  const [minDate, setMinDate] = useState<Date | null>(null)
  const [maxDate, setMaxDate] = useState<Date | null>(null)

  const [durationDays, setDurationDays] = useState<number>(taskData?.variables?.leave_duration || 0)

  useEffect(() => {
    if (minDate && maxDate) {
      // Panggil fungsi hitung nonBusinessDays dan durationHours
      const { nonBusinessDays, durationHours } = countNonBusinessDaysAndDuration(minDate, maxDate, holidaysData ?? [])

      setDurationDays(nonBusinessDays)

      setValue('leave_duration', Number(nonBusinessDays))
      setValue('numberOfHours', durationHours / 3)
      setValue('requestHourFrom', '08:00')
      setValue('requestHourTo', '17:00')
      setValue('customHours', 'false')
    }
  }, [minDate, maxDate, setValue, holidaysData])

  const filterDateWithHolidays = (date: Date) => filterDate(date, holidaysData)

  const classNamesLabel = "after:content-['*'] after:text-red-400 after:text-sm font-medium"

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-2 space-x-2">
        <div>
          <label htmlFor="leave_started_date" className={classNamesLabel}>
            Tanggal Mulai Cuti
          </label>
          {!isLoadingHolidays && (
            <Controller
              name={'leave_started_date'}
              control={control}
              rules={{ required: { value: true, message: `Tanggal Mulai Cuti is required.` } }}
              render={({ fieldState }) => {
                return (
                  <>
                    <InputDate
                      id="leave_started_date"
                      dateFormat={'dd MMMM yyyy'}
                      onChange={e => {
                        setValue('leave_started_date', e && moment(e).format('DD-MM-YYYY'))
                        setMinDate(e ?? null)
                      }}
                      defaultValue={defaultValueDate?.minDate ? new Date(defaultValueDate?.minDate) : null}
                      minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
                      filterDate={filterDateWithHolidays}
                      autoComplete="off"
                    />
                    {fieldState.error && <p className="text-sm text-red-500">{fieldState.error.message}</p>}
                  </>
                )
              }}
            ></Controller>
          )}
          {isLoadingHolidays && (
            <>
              <div role={'status'}>
                <Spinner />
              </div>
            </>
          )}
        </div>

        <div>
          <label htmlFor="leave_ended_date" className={classNamesLabel}>
            Tanggal Selesai Cuti
          </label>
          {!isLoadingHolidays && (
            <Controller
              name={'leave_ended_date'}
              control={control}
              rules={{ required: { value: true, message: `Tanggal Selesai Cuti is required.` } }}
              render={({ fieldState }) => {
                return (
                  <>
                    <InputDate
                      id="leave_ended_date"
                      dateFormat={'dd MMMM yyyy'}
                      onChange={e => {
                        setValue('leave_ended_date', e && moment(e).format('DD-MM-YYYY'))
                        setMaxDate(e ?? null)
                      }}
                      defaultValue={defaultValueDate?.maxDate ? new Date(defaultValueDate?.maxDate) : null}
                      minDate={minDate ?? new Date(new Date().setDate(new Date().getDate() + 1))}
                      filterDate={filterDateWithHolidays}
                      autoComplete="off"
                    />
                    {fieldState.error && <p className="text-sm text-red-500">{fieldState.error.message}</p>}
                  </>
                )
              }}
            ></Controller>
          )}
          {isLoadingHolidays && <Spinner />}
        </div>
      </div>

      <div className="grid grid-cols-2 space-x-2">
        <div>
          <label htmlFor="leave_duration" className={classNamesLabel}>
            Durasi Cuti (Hari)
          </label>
          <Controller
            name={'leave_duration'}
            control={control}
            rules={{ required: { value: true, message: `Durasi Cuti (Hari) is required.` } }}
            render={({ fieldState }) => {
              return (
                <>
                  <Input
                    id="leave_duration"
                    onChange={e => {
                      setValue('leave_duration', e.target.value)
                    }}
                    value={durationDays}
                    defaultValue={taskData?.variables?.leave_duration ?? null}
                    disabled
                  />
                  {fieldState.error && <p className="text-sm text-red-500">{fieldState.error.message}</p>}
                </>
              )
            }}
          ></Controller>
        </div>
      </div>
    </div>
  )
}
